var timeout: NodeJS.Timeout;
export const debounce = (func: (args: any) => any, wait: number) => {
    if(timeout){
        clearTimeout(timeout);
    }
    return function executedFunction (args: any) {
        const later = () => {
            clearTimeout(timeout);
            func(args);
        };

        timeout = setTimeout(later, wait);
    };
};